// src/redux/reducers/rootReducer.ts
import { combineReducers } from "redux";
import confirmationDialogReducer from "./confirmationDialogReducer";
import { notificationReducer } from "./notificationReducer";
import fullScreenReducer from "./fullScreenReducer";

const rootReducer = combineReducers({
  confirmationDialog: confirmationDialogReducer,
  notification: notificationReducer,
  fullScreenReducer: fullScreenReducer
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
